import { KEY_CODES } from 'aria-viewer/tour/constants/index'
import { KEY_PRESSED } from 'aria-viewer/modal/constants/ModalSources'
import { closeAllModals } from 'aria-viewer/modal/modalActions'
import { hideDrawer } from 'aria-viewer/drawer/drawerMenuActions'
import { hideSupplementalMediaView } from 'aria-viewer/players/supplementalmedia/supplementalMediaActions'
import { hideCustomMedia, nextPoint, prevPoint } from 'aria-viewer/tour/tourActions'
import { openRegistrationModal } from 'aria-viewer/registration/registrationActions'
import { sendKeyboardPress } from 'aria-viewer/analytics/analyticActions'
import { previousStop, nextStop } from 'aria-viewer/stopselector/stopsListActions'
import { toggleStats } from 'aria-viewer/stats'

const KEYBOARD_INITIALIZED = 'Keyboard.KEYBOARD_INITIALIZED'

const Redux = {
    dispatch: () => {},
    getState: () => {},
}

const keyboardBinding = {
    [KEY_CODES.ESCAPE]: e => {
        Redux.dispatch(closeAllModals())
        Redux.dispatch(hideDrawer())
        Redux.dispatch(hideSupplementalMediaView())
        Redux.dispatch(hideCustomMedia({ initializeMainMedia: false }))
    },
    [KEY_CODES.UP]: e => Redux.dispatch(nextPoint()),
    [KEY_CODES.DOWN]: e => Redux.dispatch(prevPoint()),
    [KEY_CODES.LEFT]: e => previousStop(e)(Redux.dispatch, Redux.getState),
    [KEY_CODES.RIGHT]: e => nextStop(e)(Redux.dispatch, Redux.getState),
    [KEY_CODES.X]: e => {
        if (e.ctrlKey) {
            Redux.dispatch(openRegistrationModal(KEY_PRESSED))
            Redux.dispatch(sendKeyboardPress('register', 88))
        }
    },
}

const handleKeys = evt => {
    const targetHasKeyboard = evt.target.className.indexOf('requiresKeyboardControl') >= 0
    const state = Redux.getState()
    const isModalOpen =
        state.getIn(['modal', 'modalStack']).size > 0 || state.getIn(['interactiveElements', 'modal', 'id']) !== null

    const triggerKeyboardEvent = !targetHasKeyboard && !isModalOpen && keyboardBinding[evt.which] !== undefined

    if (evt.ctrlKey && evt.shiftKey && evt.which == KEY_CODES.S) Redux.dispatch(toggleStats())
    else if (triggerKeyboardEvent) keyboardBinding[evt.which](evt)
}

let isKeyboardInitialized = false

export const intializeKeyboard = () => (dispatch, getState) => {
    const isDeviceMobile = getState().getIn(['device', 'isDeviceMobile'])

    if (!isKeyboardInitialized && !isDeviceMobile) {
        isKeyboardInitialized = true

        Redux.dispatch = dispatch
        Redux.getState = getState

        document.addEventListener('keydown', handleKeys)

        dispatch({
            type: KEYBOARD_INITIALIZED,
        })
    }
}
